export function initialize(global) {
    loadSieFlagCheck(global);
    sieFlagDetection(global);
}

function sieFlagDetection(global) {
    let sie_flag = global.document.getElementById('sie_flag');
    if (sie_flag === null) {
        return;
    }

    sie_flag.addEventListener('change', event => {
        let el = event.currentTarget;
        let hidden_sie = global.document.getElementById('hidden_sie');
        if (hidden_sie !== null) {
            hidden_sie.remove();
        }

        let cart = global.document.getElementById('cart');
        if (el.checked) {
            cart.innerHTML += `
                <input id="hidden_sie"
                       type="hidden"
                       value="yes"
                       name="attributes[sie_flag]"
                       checked />
            `;

            if (typeof Storage !== 'undefined') {
                localStorage.setItem('SIEFLAG', 'checked');
            }
        } else {
            cart.innerHTML += `
                <input id="hidden_sie"
                       type="hidden"
                       value="no"
                       name="attributes[sie_flag]" />
            `;

            if (typeof Storage !== 'undefined') {
                localStorage.setItem('SIEFLAG', 'unchecked');
            }
        }
    });
}

// Sets the sie_flag based on the local storage, not on the cart attributes
// So the local storage value is based directly on what the checkbox in the basket
// page is. This has to run before the #cart form is submitted on leaving the basket page.
function loadSieFlagCheck(global) {
    // Check if browser supports it
    if (typeof Storage === 'undefined') {
        throw new Error('Browser does not support web storage...');
    } else {
        let sie_flag = localStorage.getItem('SIEFLAG');

        //If null then store sie_flag_status as unchecked
        if (sie_flag === null) {
            localStorage.setItem('SIEFLAG', 'unchecked');
        } else {
            let sie_flag_el = global.document.getElementById('sie_flag');
            if (sie_flag_el === null) {
                return;
            }

            let cart = global.document.getElementById('cart');

            let hidden_sie = global.document.getElementById('hidden_sie');
            if (hidden_sie !== null) {
                hidden_sie.remove();
            }

            //Retrieve sie_flag_status
            if (sie_flag === 'checked') {
                sie_flag_el.checked = true;
                cart.innerHTML += `
                    <input id="hidden_sie"
                           type="hidden"
                           value="yes"
                           name="attributes[sie_flag]"
                           checked />
                `;
            } else {
                sie_flag_el.checked = false;
                cart.innerHTML += `
                    <input id="hidden_sie"
                           type="hidden"
                           value="no"
                           name="attributes[sie_flag]" />
                `;
            }
        }
    }
}
